import React, { FC } from "react";

const CSSolidLineComponent: FC = (props: any) => {
    return (
        <div
            className={`tw-mt-2 tw-box-border tw-w-auto tw-border-t-[1px] tw-border-solid tw-border-edge`}
        />
    );
};

export default CSSolidLineComponent;
